module.exports = __webpack_public_path__ + "static/media/crumbaugh.99bf3227.jpg";